// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteProjectModal_dialog__2340g"};